import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GATrackingHubPageCardClickEvent implements GATrackingEvent {

  constructor(private payload: any) { }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.HubPageCardClick;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.HubPageCardClick,
      label: this.payload.label,
      gtmCustom: {
        'content-name': this.payload.gtmCustom['content-name']
      }
    };
  }
}
